/**
 * This file lists all known API routes called within the project
 */

export const API_ROUTES = {
  adyenPaymentMethods: {
    get: `getAdyenPaymentMethods`
  },
  availabilities: {
    get: `getAvailabilities`,
    summary: `getAvailabilitiesSummary`
  },
  authToken: {
    get: `getAuthToken`
  },
  booking: {
    getByUuid: (bookingUuid: string) => `bookings/${bookingUuid}` as const,
    getByChargeToken: `getBookingByChargeToken`,
    getBySetUpIntentId: `getBookingBySetupIntentId`,
    patch: (bookingUuid: string) => `bookings/${bookingUuid}` as const,
    post: `booking`,
    chargeAuthorize: (bookingId: number) => `bookings/${bookingId}/charge/authorize` as const,
    confirmCharge: (bookingId: number) => `bookings/${bookingId}/confirm-charge` as const,
    confirmImprint: (bookingId: number) => `bookings/${bookingId}/charge/confirmImprint` as const
  },
  checkoutOrder: {
    post: `checkout-order`
  },
  mandatoryFields: {
    get: `getMandatoryFields`
  },
  offers: {
    get: `getOffers`
  },
  optin: {
    put: `patchOptin`
  },
  privatisation: {
    post: `privatisation`
  },
  products: {
    get: `getProducts`
  },
  restaurantInfo: {
    get: `getRestaurantInfo`
  },
  voucher: {
    validate: `validateVoucher`
  },
  widgetParams: {
    get: `getWidgetParams`
  }
} as const

type Leaves<T> = T extends string
  ? T
  : T extends (...args: any[]) => infer R
    ? R
    : T extends object
      ? { [K in keyof T]: Leaves<T[K]> }[keyof T]
      : never

export type ApiRoute = Leaves<typeof API_ROUTES>

/** FUTURE PROOF : make sure this file is maintained correctly */

// Fails if ApiRoute widened to string
type _ApiRouteIsNotString = string extends ApiRoute ? never : true

// If the following line errors, it means you've added a dynamic API route without `as const`, hence ApiRoute is a string and not a narrowed type : please fix the API_ROUTES
const _assertApiRouteIsNarrow: _ApiRouteIsNotString = true
